import auditLogs from './auditLogs.json';
import components from './components.json';

export default {
  components,
  auditLogs,
};
